import { get, ref } from 'firebase/database';
import { sortPeople } from '../../Helpers/sortPeople';
import { Person } from '../../Models/person';
import { database } from '../firebase';

export const getAllPeople: () => Promise<Person[]> = async () => {
    let people: Person[] = [];

    try {
        const snapshot = await get(ref(database, 'people'));

        if (snapshot.exists()) {
            snapshot.forEach((childSnapshot) => {
                const person: Person = childSnapshot.val();
                people.push(person);
            });
        }
        return sortPeople(people);
    } catch (err) {
        throw err;
    }
};
